import type { IHeatmapAnalytics } from '../../types';

import { EVisitorType, EDeviceType, EHeatmapClickType } from '../../types';

export const MOCK_HEATMAP_ANALYTICS: IHeatmapAnalytics = {
  deviceTypeDistribution: [
    {
      deviceType: EDeviceType.Desktop,
      totalClicks: 85,
      totalSessions: 40,
      engagedSessions: 20,
      totalVisitors: 30,
      totalPageViewed: 100,
      totalPageViewedHaveTimeOnPage: 50,
      totalTimeOnPage: 1000,
      totalSessionsThatCompletedCheckout: 10,
      totalRevenue: 1000,
      clickTypes: [
        { type: EHeatmapClickType.STANDARD, totalCount: 60 },
        { type: EHeatmapClickType.ALL, totalCount: 85 },
        { type: EHeatmapClickType.DEAD, totalCount: 10 },
        { type: EHeatmapClickType.RAGE, totalCount: 8 },
        { type: EHeatmapClickType.ERROR, totalCount: 4 },
        { type: EHeatmapClickType.FIRST, totalCount: 2 },
        { type: EHeatmapClickType.LAST, totalCount: 1 },
      ],
      visitors: [
        { type: EVisitorType.NEW, totalCount: 20 },
        { type: EVisitorType.RETURNING, totalCount: 10 },
      ],
    },
    {
      deviceType: EDeviceType.Mobile,
      totalClicks: 42,
      totalSessions: 25,
      engagedSessions: 15,
      totalVisitors: 20,
      totalPageViewed: 50,
      totalPageViewedHaveTimeOnPage: 25,
      totalTimeOnPage: 500,
      totalSessionsThatCompletedCheckout: 5,
      totalRevenue: 500,
      clickTypes: [
        { type: EHeatmapClickType.STANDARD, totalCount: 28 },
        { type: EHeatmapClickType.DEAD, totalCount: 6 },
        { type: EHeatmapClickType.ALL, totalCount: 42 },
        { type: EHeatmapClickType.RAGE, totalCount: 5 },
        { type: EHeatmapClickType.ERROR, totalCount: 2 },
        { type: EHeatmapClickType.FIRST, totalCount: 1 },
        { type: EHeatmapClickType.LAST, totalCount: 0 },
      ],
      visitors: [
        { type: EVisitorType.NEW, totalCount: 15 },
        { type: EVisitorType.RETURNING, totalCount: 5 },
      ],
    },
    {
      deviceType: EDeviceType.Tablet,
      totalClicks: 6,
      totalSessions: 5,
      engagedSessions: 3,
      totalVisitors: 4,
      totalPageViewed: 20,
      totalPageViewedHaveTimeOnPage: 10,
      totalTimeOnPage: 200,
      totalSessionsThatCompletedCheckout: 5,
      totalRevenue: 500,
      clickTypes: [
        { type: EHeatmapClickType.STANDARD, totalCount: 4 },
        { type: EHeatmapClickType.DEAD, totalCount: 1 },
        { type: EHeatmapClickType.ALL, totalCount: 6 },
        { type: EHeatmapClickType.RAGE, totalCount: 1 },
        { type: EHeatmapClickType.ERROR, totalCount: 0 },
        { type: EHeatmapClickType.FIRST, totalCount: 0 },
        { type: EHeatmapClickType.LAST, totalCount: 0 },
      ],
      visitors: [
        { type: EVisitorType.NEW, totalCount: 3 },
        { type: EVisitorType.RETURNING, totalCount: 1 },
      ],
    },
  ],
};
